import { AnnotationTransientState } from '../../../cross-team-shared/annotation/shared/state/annotation-state';
import {
  ObjectState,
  ObjectTransientInfoState,
} from '../../../cross-team-shared/annotation/shared/state/object-state';
import { SettingState } from '../../../cross-team-shared/state/setting-state';
import { OutputInfoState } from '../../../outputs/annotation/annotation-shared/annotation-providers';
import { ViewBox } from '../../../team-apis/content/view-box';
import { LutData } from '../../../team-apis/core/lut-data';
import { TaxonomyInternal } from '../../../team-apis/core/taxonomy';
import {
  ClientFeedback,
  HighlightFeedback,
  ShapeFeedback,
} from '../../../team-apis/otterdam/feedback';
import { IndividualFieldScore } from '../../../team-apis/otterdam/individual-field-score';
import {
  AbstractOutput,
  Output,
} from '../../../team-apis/otterdam/outputs/output';
import { QaFeedback } from '../../../team-apis/otterdam/task';
import { TrainingTemplate } from '../../../team-apis/otterdam/training-template';
import { User } from '../../../team-apis/otterdam/user';
import { FeedbackPopoverState } from '../../feedback/types/feedback-popover-state';
import { FieldFeedback } from '../../feedback/types/field-feedback';
import { FieldFeedbackPopoverState } from '../../feedback/types/field-feedback-popover-state';
import { HighlightState } from '../../gen-ai/types/highlight-state';
import { CategorizationAnnotationPanelState } from './categorization-annotation-panel-state';
import { FusionState, Selection } from './fusion-state';
import { H3mlState } from './h3ml-state';
import { SidePanelState } from './side-panel-state';

export type WorkspaceType =
  | 'readOnly'
  | 'production'
  | 'sampling'
  | 'preview'
  | 'login';
export type FeedbackType = 'shape' | 'client' | undefined;

export class TaskWorkspaceState extends H3mlState {
  categorizationAnnotationPanel = new CategorizationAnnotationPanelState();
  clientFeedback: ClientFeedback[] = [];
  clientFeedbackTags: string[] = [];
  currentUser!: User;
  feedbackType: FeedbackType;
  fieldFeedback: StrictRecord<number, FieldFeedback[]> = {};
  fieldFeedbackPopover: FieldFeedbackPopoverState = {};
  fusions: StrictRecord<number, FusionState> = {};
  hasFatalError = false;
  highlightFeedbacks: HighlightFeedback[] = [];
  highlightState = new HighlightState();
  individualFieldScore: StrictRecord<number, IndividualFieldScore> = {};
  lastInteractiveEventTimestamp?: number;
  lastRoundQaFeedbacks: QaFeedback[] = [];
  lastSavedDraftTimestamp?: number;
  lutData?: LutData;
  nextObjectId = 0;
  nextShapeId = 1;
  nextObjectClass?: string;
  objectSelection: Selection = {};
  objectTransientInfo: StrictRecord<number, ObjectTransientInfoState> = {};
  objects: StrictRecord<number, ObjectState> = {};
  outputAnnotationInfo: StrictRecord<AbstractOutput['name'], OutputInfoState> =
    {};
  outputTrainingScore?: StrictRecord<AbstractOutput['name'], number>;
  outputsByDisplayOrder: Output[] = [];
  qaFeedbackIsEditable = false;
  scopedObjectId?: number;
  selectedOutputName!: string;
  selectedSubmissionId?: number;
  settings = new SettingState();
  shapeFeedback: ShapeFeedback[] = [];
  feedbackPopover: FeedbackPopoverState = {
    selectedFrameRange: [0, 0],
    shapeFilterIds: [],
  };
  shapeSelection: Selection = {};
  shapeTransientInfo: StrictRecord<number, AnnotationTransientState> = {};
  sidePanel = new SidePanelState();
  splitViewOutputName?: string;
  stepId?: number;
  submissions: StrictRecord<
    number,
    {
      objects: StrictRecord<number, ObjectState>;
      shapeFeedback: ShapeFeedback[];
    }
  > = {};
  taxonomy: TaxonomyInternal = {
    sceneAttributes: {},
    objectTaxonomy: [],
    attributesByClass: {},
  };
  trainingTemplate?: TrainingTemplate;
  viewBoxes: StrictRecord<string, ViewBox> = {};
  viewBoxPadding?: number;
  workspace!: WorkspaceType;
}
